<template>
  <div class="user-info-wrapper">
    <div class="brief-info">
      <div class="user-info">
        <van-image round width="50" height="50" fit="cover" class="avatar" :src="value.avatar" />
        <span class="nickname">{{ value.nickname }}</span>
      </div>
      <div class="member_card">
        <span>会员码：{{ value.member_card }}</span>
        <span>余额：￥{{ value.credit2 }}</span>
      </div>
    </div>
    <div class="balance-info">
      <span class="tixian">提现</span>
      <div>
        <p class="title">可申请</p>
        <span class="dollar">￥</span>
        <span class="balance">{{ moneys.money_available }}</span>
      </div>
      <div class="balance-info-right">
        <div>
          <span class="title2">已申请</span>
          <span class="dollar2">￥</span>
          <span class="balance2">{{ moneys.money_used }}</span>
        </div>
        <div class="btns">
          <van-button color="#42BCFF" size="small" @click.stop="onExtract">提现</van-button>
          <van-button color="#42BCFF" size="small" @click.stop="onPay">充值</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    moneys: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onPay() {
      this.$emit('pay');
    },
    onExtract() {
      this.$emit('extract');
    },
  },
};
</script>

<style lang="less" scoped>
.user-info-wrapper {
  background-image: url('../../../assets/img/mytop.png');
  background-size: 120%;
  background-repeat: no-repeat;
  .brief-info {
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;

    .user-info {
      display: flex;
      align-items: center;
      .nickname {
        max-width: 70px;
        margin-left: 8px;
        word-wrap: break-word;
      }
    }
    .member_card {
      height: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
  }
  .balance-info {
    background-color: #fff;
    box-shadow: 0px 0px 16px 0px rgba(204, 204, 204, 0.5);
    border-radius: 6px;
    text-align: center;
    margin: 0 16px;
    padding: 16px;
    display: flex;
    justify-content: space-around;
    position: relative;
    .tixian {
      position: absolute;
      top: 8px;
      left: 8px;
      font-size: 14px;
      color: #828eff;
    }
    .dollar {
      font-size: 20px;
    }
    .balance {
      font-size: 36px;
    }
    .title {
      color: #828282;
      margin: 8px auto;
    }
    .balance-info-right {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      .dollar2 {
        font-size: 16px;
      }
      .balance2 {
        font-size: 20px;
      }
      .title2 {
        font-size: 14px;
        color: #828282;
        margin-right: 8px;
      }
      .btns {
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .van-button {
          min-width: 44px;
          height: 24px;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
